import { useState, useEffect, useRef } from "react";
import apiClient from "../../services/apiClient";
import { getCookie } from "../../utils/cookies";
import toast from "../../utils/toast";

function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve();

  if (!window.__razorpayScriptPromise) {
    window.__razorpayScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }
  return window.__razorpayScriptPromise;
}

export default function QuickDeposit() {
  const [walletType, setWalletType] = useState("");
  const [amount, setAmount] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isBalanceData, setBalanceData] = useState();
  const [paymentModes, setPaymentModes] = useState([]);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [isStatusPopupHidden, setIsStatusPopupHidden] = useState(false);
  const pollIntervalRef = useRef(null);
  const pollCountRef = useRef(0);
  const currentTidRef = useRef(null);

  useEffect(() => {
    fetchBalanceData();
    paymentModeForAddMoney();

    return () => {
      clearInterval(pollIntervalRef.current);
    };
  }, []);

  function stopPolling() {
    clearInterval(pollIntervalRef.current);
    pollIntervalRef.current = null;
  }

  function startPollingPaymentStatus(tid, initialMsg) {
    stopPolling();
    pollCountRef.current = 0;
    currentTidRef.current = tid;
    setIsStatusPopupHidden(false);
    setPaymentStatus({
      state: "pending",
      msg: initialMsg || "Waiting for payment confirmation...",
    });

    pollIntervalRef.current = setInterval(async () => {
      pollCountRef.current += 1;

      try {
        const userData = JSON.parse(getCookie("userData") || "{}");

        const res = await apiClient.post("/App/UPIPaymentUpdate", {
          appid: "ROUNDPAYAPPID13APR20191351",
          imei: "d593bdd26dfbea56",
          loginTypeID: "1",
          serialNo: "d593bdd26dfbea56",
          version: "1.0",
          TID: tid,
          session: getCookie("session") || "",
          sessionID: getCookie("sessionID") || "",
          userID: userData.userID || "",
        });

        console.log("UPIPaymentUpdate response", res);

        const statusMsg = String(res.msg || "").toUpperCase();
        if (statusMsg === "SUCCESS") {
          stopPolling();
          setIsStatusPopupHidden(false);
          setPaymentStatus({ state: "success", msg: res.msg });
          fetchBalanceData();
          return;
        }
        if (statusMsg === "FAILED" || statusMsg === "FAILURE") {
          stopPolling();
          setIsStatusPopupHidden(false);
          setPaymentStatus({ state: "failed", msg: res.msg });
          return;
        }

        if (pollCountRef.current >= 12) {
          stopPolling();
          setIsStatusPopupHidden(false);
          setPaymentStatus({
            state: "pending",
            timedOut: true,
            msg: "Still processing. Tap below to check again, or check your transaction history shortly.",
          });
          return;
        }

        setPaymentStatus({ state: "pending", msg: res.msg || "Payment is pending..." });
      } catch (err) {
        console.log("error", err);
        if (pollCountRef.current >= 12) {
          stopPolling();
        }
      }
    }, 5000);
  }

  async function checkPaymentStatusOnce(tid) {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/App/UPIPaymentUpdate", {
        appid: "ROUNDPAYAPPID13APR20191351",
        imei: "d593bdd26dfbea56",
        loginTypeID: "1",
        serialNo: "d593bdd26dfbea56",
        version: "1.0",
        TID: tid,
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        userID: userData.userID || "",
      });

      console.log("UPIPaymentUpdate response (dismiss check)", res);

      const statusMsg = String(res.msg || "").toUpperCase();
      if (statusMsg === "SUCCESS") {
        currentTidRef.current = tid;
        setIsStatusPopupHidden(false);
        setPaymentStatus({ state: "success", msg: res.msg });
        fetchBalanceData();
      } else if (statusMsg === "FAILED" || statusMsg === "FAILURE") {
        currentTidRef.current = tid;
        setIsStatusPopupHidden(false);
        setPaymentStatus({ state: "failed", msg: res.msg });
      }
    } catch (err) {
      console.log("error", err);
    }
  }

  const fetchBalanceData = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/App/v2/GetBalance", {
        paymentID: 0,
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setBalanceData(res);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const paymentModeForAddMoney = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/App/PaymentModeForAddmoney", {
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setPaymentModes(res.paymentModes || []);
      } else {
        setPaymentModes([]);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  async function handlePaymentOptionClick(option) {
    if (!walletType) {
      toast.error("Please select a wallet type");
      return;
    }
    const numAmount = Number(amount);
    if (!amount || isNaN(numAmount) || numAmount <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    setSelectedOption(option.oid);
    setIsProcessingPayment(true);
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const gatewayRes = await apiClient.post("/App/ChoosePaymentGateway", {
        // isUPI: option.name.toUpperCase().includes("UPI"),
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      // console.log("ChoosePaymentGateway response", gatewayRes);

      const selectedGateway =
        gatewayRes.pGs?.[0] || gatewayRes.pgForUPI?.[0];
      if (!selectedGateway) {
        toast.error("No payment gateway available");
        return;
      }

      const res = await apiClient.post("/App/PGatewayTransaction", {
        amount: amount,
        oid: String(option.oid),
        upgid: String(selectedGateway.id),
        walletID: walletType,
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      const rPayRequest = res.pGModelForApp?.rPayRequest;
      const tid = res.pGModelForApp?.tid;
      const hasOtherGatewayResponse =
        res.pGModelForApp?.aggrePayRequest ||
        res.pGModelForApp?.upiGatewayRequest ||
        res.pGModelForApp?.usdtpgRequest ||
        res.pGModelForApp?.cashFreeResponse;

      if (res.statuscode == 1 && rPayRequest) {
        await loadRazorpayScript();
        const retryEnabled = !!rPayRequest.retry;

        const rzp = new window.Razorpay({
          key: rPayRequest.key_id,
          amount: Math.round(rPayRequest.amount * 100),
          order_id: rPayRequest.order_id,
          name: rPayRequest.name,
          description: rPayRequest.description || "",
          image: rPayRequest.image,
          prefill: {
            name: rPayRequest.prefill_name,
            contact: rPayRequest.prefill_contact,
            email: rPayRequest.prefill_email,
          },
          retry: { enabled: retryEnabled },
          handler: () => {
            if (tid) {
              startPollingPaymentStatus(tid);
            }
          },
          modal: {
            ondismiss: () => {
              setIsProcessingPayment(false);
              if (!pollIntervalRef.current && tid) {
                checkPaymentStatusOnce(tid);
              }
            },
          },
        });

        rzp.on("payment.failed", (failure) => {
          console.log("Razorpay payment.failed", failure?.error);
          if (retryEnabled) {
            return;
          }
          if (tid) {
            startPollingPaymentStatus(
              tid,
              failure?.error?.description
                ? `${failure.error.description} — confirming with server...`
                : undefined,
            );
          }
        });

        rzp.open();
      } else if (res.statuscode == 1 && hasOtherGatewayResponse) {
        toast.error(
          "This payment mode isn't supported yet. Please choose another payment mode.",
        );
      } else {
        toast.error(res.msg || "Failed to initiate payment");
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Failed to initiate payment. Please try again.");
    } finally {
      setIsProcessingPayment(false);
    }
  }

  function formatAmount(amount) {
    const num = Number(amount) || 0;
    return `₹${num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  const fundProcessWallets = (isBalanceData?.balanceData || []).filter(
    (w) => w.inFundProcess,
  );
  const selectedWallet = fundProcessWallets.find(
    (w) => String(w.id) === walletType,
  );
  const activePaymentModes = paymentModes.filter((m) => m.isActive);

  return (
    <div className="content">
      <section className="page active" id="page-quick-deposit">
        <h3 className="section-title">Quick Deposit</h3>

        <div className="card" style={{ marginBottom: 16 }}>
          <div className="grid grid-2">
            <div className="field">
              <label>Wallet Type</label>
              <select
                value={walletType}
                onChange={(e) => setWalletType(e.target.value)}
              >
                <option value="">:: Select Wallet ::</option>
                {fundProcessWallets.map((wallet) => (
                  <option key={wallet.id} value={wallet.id}>
                    {wallet.walletType} — {formatAmount(wallet.balance)}
                  </option>
                ))}
              </select>
              <div
                className="field-note"
                style={{ color: "var(--text-faint)" }}
              >
                Wallet Balance:
                {selectedWallet ? formatAmount(selectedWallet.balance) : "-"}
              </div>
            </div>
            <div className="field">
              <label>Enter Amount</label>
              <input
                type="number"
                placeholder="Enter Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="pay-options">
          {activePaymentModes.map((option) => (
            <div
              key={option.oid}
              className={`pay-opt${selectedOption === option.oid ? " selected" : ""}`}
              onClick={() => handlePaymentOptionClick(option)}
              style={{
                cursor: isProcessingPayment ? "wait" : "pointer",
                opacity: isProcessingPayment ? 0.6 : 1,
              }}
            >
              <div className="radio" />
              <div className="pay-opt-info">
                <div className="t">{option.name.toUpperCase()}</div>
                <div className="s" style={{ color: "var(--red)" }}>
                  Charges:{" "}
                  {option.chargeAmtType
                    ? formatAmount(option.charge)
                    : `${option.charge}%`}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {paymentStatus && !isStatusPopupHidden && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(6,8,12,0.72)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: 16,
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 400,
              background:
                "linear-gradient(160deg, var(--bg-elev-2), var(--bg-elev))",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius)",
              padding: "36px 32px",
              boxShadow: "0 40px 100px -30px rgba(0,0,0,0.7)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: 68,
                height: 68,
                margin: "0 auto 20px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background:
                  paymentStatus.state === "success"
                    ? "rgba(51,214,159,0.12)"
                    : paymentStatus.state === "failed"
                      ? "var(--red-dim)"
                      : "rgba(230,181,89,0.12)",
                boxShadow:
                  paymentStatus.state === "success"
                    ? "0 0 0 6px rgba(51,214,159,0.1)"
                    : paymentStatus.state === "failed"
                      ? "0 0 0 6px rgba(255,93,108,0.1)"
                      : "0 0 0 6px rgba(230,181,89,0.1)",
              }}
            >
              {paymentStatus.state === "success" && (
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--green)"
                  strokeWidth={2.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  width={30}
                  height={30}
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              )}
              {paymentStatus.state === "failed" && (
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--red)"
                  strokeWidth={2.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  width={28}
                  height={28}
                >
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              )}
              {paymentStatus.state === "pending" && (
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--gold)"
                  strokeWidth={2.5}
                  strokeLinecap="round"
                  width={28}
                  height={28}
                  style={{
                    animation: "qd-spin 1s linear infinite",
                    transformOrigin: "center",
                  }}
                >
                  <path d="M12 3a9 9 0 106.4 2.64" opacity="0.9" />
                </svg>
              )}
            </div>
            <h3
              style={{
                color: "var(--text)",
                fontSize: 19,
                fontWeight: 800,
                margin: "0 0 8px",
              }}
            >
              {paymentStatus.state === "success"
                ? "Payment Successful"
                : paymentStatus.state === "failed"
                  ? "Payment Failed"
                  : paymentStatus.timedOut
                    ? "Still Processing"
                    : "Confirming Payment"}
            </h3>
            <p
              style={{
                color: "var(--text-dim)",
                fontSize: 13.5,
                lineHeight: 1.6,
                margin: paymentStatus.state === "pending" && !paymentStatus.timedOut && paymentStatus.msg ? "0 0 4px" : "0 0 26px",
              }}
            >
              {paymentStatus.state === "success"
                ? "Your payment was received and your wallet has been credited successfully."
                : paymentStatus.state === "failed"
                  ? "We couldn't complete this payment. No amount has been deducted — please try again."
                  : paymentStatus.timedOut
                    ? "This is taking longer than expected. You can check again now, or check your transaction history shortly."
                    : "Hang tight, we're waiting for your bank or UPI app to confirm this payment."}
            </p>
            {paymentStatus.state === "pending" &&
              !paymentStatus.timedOut &&
              paymentStatus.msg && (
                <p
                  style={{
                    color: "var(--text-faint)",
                    fontSize: 12,
                    margin: "0 0 22px",
                  }}
                >
                  {paymentStatus.msg}
                </p>
              )}
            <style>
              {`@keyframes qd-spin { to { transform: rotate(360deg); } }`}
            </style>
            {paymentStatus.state === "pending" && paymentStatus.timedOut ? (
              <div style={{ display: "flex", gap: 10 }}>
                <button
                  type="button"
                  className="btn-sm"
                  style={{ flex: 1 }}
                  onClick={() => setPaymentStatus(null)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn-primary"
                  style={{ flex: 1 }}
                  onClick={() => {
                    if (currentTidRef.current) {
                      startPollingPaymentStatus(currentTidRef.current);
                    }
                  }}
                >
                  Check Status Again
                </button>
              </div>
            ) : (
              <button
                type="button"
                className={paymentStatus.state === "pending" ? "btn-sm" : "btn-primary"}
                style={{ width: "100%" }}
                onClick={() => {
                  if (paymentStatus.state === "pending") {
                    setIsStatusPopupHidden(true);
                  } else {
                    stopPolling();
                    setPaymentStatus(null);
                  }
                }}
              >
                {paymentStatus.state === "pending"
                  ? "Continue in background"
                  : "Close"}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
